import { Skeleton } from '@gitbook/spine-react';

import { UserAvatarSkeleton } from '../Users';

export function CommentCardSkeleton(props: { count: number }) {
    const { count = 1 } = props;

    return (
        <div className="flex flex-1 flex-col p-2">
            {Array.from({ length: count }, (_, i) => (
                <div key={i} className="flex w-full flex-col gap-1 p-3">
                    {/* Comment avatar and name */}
                    <div className="flex items-center gap-4">
                        <UserAvatarSkeleton size="sm" />
                        <Skeleton className="h-4 w-1/4" />
                    </div>

                    <div className="ml-10 flex flex-col gap-2">
                        {/* Comment preview/quote */}
                        <div className="flex w-full items-center gap-2">
                            <Skeleton className="h-5 w-0.5 rounded-full" />
                            <Skeleton className="h-4 w-1/2" />
                        </div>
                        {/* Comment text */}
                        <div className="flex flex-1 flex-col space-y-2">
                            <Skeleton className="h-4 w-1/2" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
